/**
 * ChatScreen - Async chat between visitor and resident during a ring.
 * Renders ChatPanel with a GB-styled chrome and a back button.
 */
import { useEffect, useCallback } from 'react';
import { useApp } from '@/state/store';
import { ChatPanel } from '@/components/ChatPanel';

export function ChatScreen() {
  const { ringId, closeChat, showToast } = useApp();

  const handleEnded = useCallback(() => {
    showToast('Llamada finalizada', 'info');
    closeChat();
  }, [showToast, closeChat]);

  // B = back to home (GB hardware button)
  useEffect(() => {
    const onB = () => closeChat();
    window.addEventListener('vicin-gb:b', onB);
    return () => window.removeEventListener('vicin-gb:b', onB);
  }, [closeChat]);

  if (!ringId) {
    // Defensive: nothing to chat about. Send user home.
    return (
      <div className="gb-screen">
        <div className="gb-body">
          <div className="gb-center">
            <div className="gb-pix gb-pix-sm">SIN TIMBRE ACTIVO</div>
            <button onClick={closeChat} className="gb-action">VOLVER</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="gb-screen">
      <div className="gb-status">
        <div className="gb-status-left">
          <span className="gb-status-dot" />
          <span className="gb-pix gb-pix-xs">CHAT · TIMBRE</span>
        </div>
        <div className="gb-status-right">
          <span className="gb-pix gb-pix-xs">[B] SALIR</span>
        </div>
      </div>

      <div className="gb-body" style={{ display: 'flex', flexDirection: 'column' }}>
        <ChatPanel
          ringId={ringId}
          mySide="resident"
          onRingEnded={handleEnded}
          showEndButton
        />
      </div>
    </div>
  );
}